import PostQualificationThanks from "./PostQualificationThanks.vue";
export default PostQualificationThanks;
